import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import Crown from '@src/assets/images/crown.svg';
import UserOutlined from '@src/assets/images/user-outlined.svg';
import React from 'react';
import CommonInput from '@src/new-components/Input/CommonInput';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import CommonButton from '@src/new-components/Button';
import { PROVIDE_EMAIL_URL } from '@src/constants/email';
import useForm from '@src/hooks/useForm';
import { createValidationSchema } from '@src/utils/form';

const ProvideEmailToUseFeatureDialog = ({ onClose }) => {
  const { t } = useTranslation();

  const validationSchema = createValidationSchema();

  const onSubmit = (values) => {
    window.open(`${PROVIDE_EMAIL_URL}/?email=${values.email}`, '_blank');
  };

  const { values, errors, handleSubmit, handleChange } = useForm({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit,
  });

  return (
    <ActionDialog
      image={Crown}
      open
      onClose={onClose}
      title={t('emailVerification')}
      description={t('emailVerificationDescription')}
      buttonText={t('share')}
      width="512px"
      styleDescription={{
        textAlign: 'center',
      }}
      actionComponent={
        <CommonButton
          variant="contained"
          customStyle={{
            width: '102px',
            height: '40px',
            borderRadius: '8px',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
          onClick={handleSubmit}
        >
          {t('continueUsingFeature')}
        </CommonButton>
      }
      contentComponent={
        <CommonInput
          sx={{
            '& .MuiInputBase-root': {
              padding: '6px 16px',
              borderRadius: '12px',
              boxSizing: 'border-box',
            },
          }}
          error={errors.email}
          helperText={errors.email}
          startAdornment={
            <img
              src={UserOutlined}
              alt="user-outlined"
              width={24}
              height={24}
            />
          }
          type="email"
          placeholder={t('inputYourEmail')}
          value={values.email}
          onChange={(e) => handleChange(e.target.value)('email')}
        />
      }
    />
  );
};

export default ProvideEmailToUseFeatureDialog;
